import React, { Component } from 'react';
import { Toolbar, Widget, Form, FormDelete, FormShare } from './components/index'
import { Dashboard as DashboardLayout } from '../../layouts'
import { Grid, CircularProgress } from '@material-ui/core';
import { Dialog } from '@progress/kendo-react-dialogs'
import { injectIntl, FormattedMessage } from 'react-intl';
import { withAlert } from 'react-alert';
import hubAPI from '../../services/hubAPI';
import HUBContext from '../../services/HUBContext';

export class index extends Component {
    constructor(props) {
        super(props);

        let breadcrumb = [
            {type: 'link', text: this.props.intl.formatMessage({ id: 'home', defaultMessage: 'Home' }), to:'/dashboard'  },
			{type: 'selector'}
        ];

        this.state = {
            companyID: 0,
            breadcrumb: breadcrumb,
            status: 'ready',
            statusForm: 'ready',
            statusDelete: 'ready',
            statusShare: 'ready',
            activeForm: false,
            activeDelete: false,
            activeShare: false,
            activeValidate: false,
            selectedID: 0,
            selectedData: [],
            pivot: 'save',
            customDashboardList: {
                data: [],
                count: 0,
                pageSize: 10,
                pageIndex: 0
            },
            kpiList: {
                data: [],
                count: 0,
                pageSize: 10,
                pageIndex: 0
            },
            userList: {
                data: [],
                count: 0,
                pageSize: 10,
                pageIndex: 0
            }
        };
    }
    showAlert = (message, type) => {
        const { alert } = this.props;
        switch (type) {
            case 'error':
                alert.error(message);
                break;

            default:
                alert.show(message);
                break;
        }
    }

    //TRANSITIONS VIEWS
    showForm = () => {
        this.setState({ selectedData: [] }, () => {
            this.setState({
                activeForm: !this.state.activeForm, pivot: 'save',
            })
        });
    }
    showEditForm = (data) => {
        this.setState({ selectedData: data }, () => {
            this.setState({ activeForm: !this.state.activeForm, pivot: 'edit', })
        });
    }
    showDelete = (id) => {
        this.setState({ activeDelete: !this.state.activeDelete, selectedID: id });
    }
    showShare = (data) => {
        this.setState({ selectedData: data }, () => {
            this.setState({
                activeShare: !this.state.activeShare
            })
        });
    }
    showValidate = () => {
        this.setState({ showValidate: !this.state.showValidate })
    }

    //LOAD DATA
    loadCustomDashboards = () => {
        this.setState({ status: 'loading' });
        hubAPI.get('/api/v1/Dashboard?pageIndex=0&pageSize=0&dashboardTypeID=2').then(response => {
            this.setState({ customDashboardList: response.data, status: 'ready' });
        }).catch(err => {
            this.setState({ status: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }

            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);

            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    loadKpi = () => {
        this.setState({ status: 'loading' });
        hubAPI.get('/api/v1/Dashboard/kpi?pageIndex=0&pageSize=0').then(response => {

            this.setState({ kpiList: response.data, status: 'ready' });
        }).catch(err => {
            this.setState({ status: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }

            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);

            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    loadUsers = () => {
        this.setState({ status: 'loading' });
        hubAPI.get(`/api/v1/Company/${this.state.companyID}/user?pageIndex=0&pageSize=0`).then(response => {
            this.deleteMyUser(response.data.data);
            this.setState({ userList: response.data, status: 'ready' });
        }).catch(err => {
            this.setState({ status: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: //this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' }));
                        break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }

            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);

            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }


    reload = () => {
        this.loadCustomDashboards();
        this.setState({ activeDelete: false, activeForm: false, activeShare: false, activeValidate: false });
    }

    //CREATE OBJECT TO SAVE OR EDIT
    createObj = (name, kpiList) => {
        const widgets = kpiList.map((widget, index) => {
            let x = 0;
            let y = Math.floor(index / 3);
            let i = index - (y * 3);

            if (i > 0 && (i + 1) % 3 === 0) x = 8;
            else if (i >= 0 && (i + 1) % 2 === 0) x = 4;
            
            return {
                'dashboardWidgetID': !widget.dashboardWidgetID ? 0 : widget.dashboardWidgetID,
                'componentKey': widget.widgetComponentKey,
                'title': widget.name,
                'xs': x,
                'sm': y,
                'lg': 4,
                'xl': 2,
                'sort': index + 1,
                'urlRequest': widget.widgetUrlRequest,
                'xAxisLabel': widget.widgetXAxisLabel,
                'yAxisLabel': widget.widgetYAxisLabel,
                'toDashboard': widget.widgetToDashboard,
                'xGroupsExclude': widget.widgetXGroupsExclude,
                'yGroupsExclude': widget.widgetYGroupsExclude,
                'measure': widget.widgetMeasure,
                'measureConfig': widget.widgetMeasureConfig,
                'dashboardWidgetGroupID': !!widget.dashboardWidgetGroupID ? widget.dashboardWidgetGroupID : null,
                'chartTypes': widget.chartTypes
            };
        });

        return (Object.assign({}, {
            'dashboardID': this.state.selectedData.length !== 0 ? this.state.selectedData.dashboardID : 0,
            'dashboardTypeID': 2,
            'name': name,
            'isPinned': this.state.selectedData.length !== 0 ? this.state.selectedData.isPinned : false,
            'dashboardWidgets': widgets
        })
        )
    }

    //DELETE CURRENT USER
    deleteMyUser = (array) => {
        var i = 0
        array.map((field) => {
            if (field.userID === localStorage.getItem("userId")) {
                array.splice(i, i + 1)
            }
            i++;
            return true;
        })
    }

    //SAVE CUSTOM DASHBOARD
    saveCustomDashboard = (name, kpiList) => {
        let obj = this.createObj(name, kpiList);
        this.setState({ statusForm: 'loading' });
        hubAPI.post('/api/v1/Dashboard', obj).then(response => {
            this.showAlert(this.props.intl.formatMessage({ id: 'createSuccess', defaultMessage: 'Record created successfully' }))
            this.setState({ statusForm: 'ready' }, () => { this.reload() });
        }).catch(err => {
            this.setState({ statusForm: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }
            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);
            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    //EDIT CUSTOM DASHBOARD
    editCustomDashboard = (name, kpiList) => {
        let obj = this.createObj(name, kpiList);
        this.setState({ statusForm: 'loading' });
        hubAPI.put('/api/v1/Dashboard', obj).then(response => {
            this.showAlert(this.props.intl.formatMessage({ id: 'editedSuccess', defaultMessage: 'Record edited successfully' }))
            this.setState({ statusForm: 'ready' }, () => { this.reload() });
        }).catch(err => {
            this.setState({ statusForm: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }
            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);
            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    //DELETE CUSTOM DASHBOARD
    deleteCustomDashboard = () => {
        this.setState({ statusDelete: 'loading' });
        hubAPI.delete(`/api/v1/Dashboard/${this.state.selectedID}`).then(response => {
            this.showAlert(this.props.intl.formatMessage({ id: 'deleteSuccess', defaultMessage: 'Record deleted successfully' }))
            this.setState({ statusDelete: 'ready' }, () => { this.reload() });
        }).catch(err => {
            this.setState({ statusDelete: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }

            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);
            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    //VALIDATE 3 FAVORITES
    validateFav = () => {
        var i = 0;
        this.state.customDashboardList.data.map((field) => {
            if (field.isPinned === true) { i++; }
            return true;
        })
        if (i >= 3) {
            return false;
        }
        else {
            return true;
        }
    }

    //ADD FAVORITE
    addFavorite = (data) => {
        if (this.validateFav() === false && data.isPinned === false) {
            this.showValidate();
        }
        else {
            this.setState({ status: 'loading' });
            hubAPI.put(`/api/v1/Dashboard/${data.dashboardID}/togglePinned`).then(() => {
                this.setState({ status: 'ready' }, () => { this.reload() });
            }).catch(err => {
                this.setState({ status: 'ready' })
                if (err.response) {
                    switch (err.response.status) {
                        case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                        case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                        case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                        default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                    }
                } else if (err.request) {
                    this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                    console.log(err.request);
                } else
                    this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
            })
        }
    }

    //CREATE ARRAY ID USERS
    createArrayUsers = (data) => {
        let array = [];
        data.map((element) => {
            array.push(element.userID)
            return true;
        })
        return array;
    }

    //SHARE CUSTOM DASHBOARD
    shareCustomDashboard = (data) => {
        this.setState({ statusShare: 'loading' });
        hubAPI.put(`/api/v1/Dashboard/${this.state.selectedData.dashboardID}/share/${this.state.companyID}`, this.createArrayUsers(data))
        .then(() => {
            this.setState({ statusShare: 'ready' }, () => { this.reload() });
        }).catch(err => {
            this.setState({ statusShare: 'ready' })
            if (err.response) {
                switch (err.response.status) {
                    case 400: this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' })); break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' })); break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem' })); break;
                }
            } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);
            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error' }), 'error');
        })
    }

    //SUBMITING EVENT
    onSubmit = (name, kpiList) => {
        if (this.state.pivot === 'edit') {
            this.editCustomDashboard(name, kpiList)
        }
        else {
            this.saveCustomDashboard(name, kpiList)
        }
    }

    //DIALOGS COMPONENTS
    form = () => {
        if (this.state.activeForm === true) {
            return (
                <Form
                    save={this.onSubmit}
                    dataKpi={this.state.kpiList}
                    status={this.state.statusForm}
                    activeForm={this.state.activeForm}
                    showForm={this.showForm}
                    getCustomDashboard={this.getCustomDashboard}
                    selectedData={this.state.selectedData}
                />
            )
        }
    }
    shareForm = () => {
        if (this.state.activeShare === true) {
            return (
                <FormShare
                    save={this.shareCustomDashboard}
                    dataUsers={this.state.userList}
                    status={this.state.statusShare}
                    activeForm={this.state.activeShare}
                    showForm={this.showShare}
                    selectedData={this.state.selectedData}
                    companyID={this.state.companyID}
                />
            )
        }
    }
    validateForm = () => {
        if (this.state.showValidate === true) {
            return (
                <Dialog title={this.props.intl.formatMessage({ id: 'validate', defaultMessage: 'Validate' })} onClose={this.showValidate} >
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        <FormattedMessage id="cdValidate" defaultMessage="Cannot have more than 3 favorites"></FormattedMessage>
                    </p>
                </Dialog>
            )
        }
    }

    addHistory = (element) => {
        this.props.history.push("/dashboard/" + element);
    }

    componentDidMount() {
        this.context.setBreadCrumb(this.state.breadcrumb);
        this.setState({
            companyID: this.context.companyID,
            userList: {
                data: [],
                count: 0,
                pageSize: 10,
                pageIndex: 0
            }
        }, () => {
            this.loadUsers();
            this.loadKpi();
            this.loadCustomDashboards();
        })

    }
    componentDidUpdate() {
        if (this.state.companyID !== this.context.companyID) {
            this.setState({
                companyID: this.context.companyID,
                userList: {
                    data: [],
                    count: 0,
                    pageSize: 10,
                    pageIndex: 0
                }
            }, () => {
                this.loadUsers();
                this.loadKpi();
                this.loadCustomDashboards();
            });
        }
    }

    render() {
        if (this.state.status === 'ready') {
            return (
                <DashboardLayout title={this.props.intl.formatMessage({ id: 'customDashboard', defaultMessage: 'Custom Dashboard' })} >
                    <Grid container spacing={1} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '0px' }}>
                            <Toolbar showForm={this.showForm} />
                            {<FormDelete status={this.state.statusDelete} showDelete={this.showDelete} deleteCustomDashboard={this.deleteCustomDashboard}></FormDelete>}
                            {this.form()}
                            {this.shareForm()}
                            {this.validateForm()}
                        </Grid>
                        <Widget
                            data={this.state.customDashboardList}
                            status={this.state.statusForm}
                            showForm={this.showEditForm}
                            showDelete={this.showDelete}
                            showShare={this.showShare}
                            favorite={this.addFavorite}
                            share={false}
                            addHistory={this.addHistory}
                        />
                    </Grid>
                </DashboardLayout>
            )
        }
        else {
            return (
                <DashboardLayout title={this.props.intl.formatMessage({ id: 'customDashboard', defaultMessage: 'Custom Dashboard' })} >
                    <CircularProgress></CircularProgress>
                </DashboardLayout>
            )
        }
    }
}


index.contextType = HUBContext;

export default withAlert()(injectIntl(index))
